export default "__VITE_ASSET__B$rh4xXt__"